module.exports = __webpack_public_path__ + "static/media/resa-logo-white.e710194c.png";